const ITEM_HEIGHT = 48;

export const SMenuPaper = {
  sx: {
    maxHeight: ITEM_HEIGHT * 5.5,
    width: "23ch",
    backgroundColor: "#F7F7F7",
    boxShadow: "0px 4px 4px rgba(229, 229, 229, 0.25)",
    border: "0.5px solid #E5E5E5",
    borderRadius: "6px",
  },
};

export const SMenuList = {
  sx: {
    paddingBottom: 0,
    paddingTop: 0,
  },
};
